// import "antd/dist/antd.compact.css";
// import "antd/dist/antd.css";
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import App from './App';
import DesignList from './components/Design/DesignList';
import ImageProcess from './components/ImageProcess/ImageProcess';
import Layout from './components/Layout/Layout';
import OrderDetail from './components/Order/OrderDetail';
import OrderList from './components/Order/OrderList';
import PrintAreaDetail from './components/PrintArea/PrintAreaDetail';
import PrintAreaList from './components/PrintArea/PrintAreaList';
import ProductTemplateDetail from './components/ProductTemplate/ProductTemplateDetail';
import ProductTemplateList from './components/ProductTemplate/ProductTemplateList';
import Statistics from './components/Stats/Statistics';
import UserList from './components/User/User';
import UserDetail from './components/User/UserDetail';
import './index.css';
import Login from './pages/Login/Login';
import SellerDepositHistory from './pages/SellerDepositHistory/SellerDepositHistory';
import reportWebVitals from './reportWebVitals';
import { Role } from './role/role';
import PrivateRoute from './routes/PrivateRoute';
import RedirectRoutePerRole from './routes/RedirectRoutePerRole';
import { store } from './store';
import GlobalStyle from './styles/Global';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <GlobalStyle />
      <Routes>
        <Route element={<App />}>
          <Route path="/login" element={<Login />} />
          <Route element={<Layout />}>
            <Route path="/" element={<RedirectRoutePerRole />} />
            <Route path="user">
              <Route
                index
                element={
                  <PrivateRoute roles={[Role.ADMIN, Role.EMPLOYEE]}>
                    <UserList />
                  </PrivateRoute>
                }
              />
              <Route
                path="create"
                element={
                  <PrivateRoute roles={[Role.ADMIN, Role.EMPLOYEE]}>
                    <UserDetail />
                  </PrivateRoute>
                }
              />
              <Route
                path=":id/edit"
                element={
                  <PrivateRoute roles={[Role.ADMIN, Role.EMPLOYEE]}>
                    <UserDetail />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route path="print-area">
              <Route
                index
                element={
                  <PrivateRoute roles={[Role.ADMIN, Role.EMPLOYEE]}>
                    <PrintAreaList />
                  </PrivateRoute>
                }
              />
              <Route
                path=":id/edit"
                element={
                  <PrivateRoute roles={[Role.ADMIN, Role.EMPLOYEE]}>
                    <PrintAreaDetail />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route path="product-templates">
              <Route
                index
                element={
                  <PrivateRoute
                    roles={[Role.ADMIN, Role.MASTER_ADMIN, Role.EMPLOYEE]}
                  >
                    <ProductTemplateList />
                  </PrivateRoute>
                }
              />
              <Route
                path=":id"
                element={
                  <PrivateRoute
                    roles={[Role.ADMIN, Role.MASTER_ADMIN, Role.EMPLOYEE]}
                  >
                    <ProductTemplateDetail />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route
              path="image"
              index
              element={
                <PrivateRoute roles={[Role.ADMIN, Role.EMPLOYEE]}>
                  <ImageProcess />
                </PrivateRoute>
              }
            />
            <Route path="order">
              <Route
                index
                element={
                  <PrivateRoute
                    roles={[Role.ADMIN, Role.SELLER, Role.EMPLOYEE]}
                  >
                    <OrderList />
                  </PrivateRoute>
                }
              />
              <Route
                path="create"
                element={
                  <PrivateRoute
                    roles={[Role.ADMIN, Role.SELLER, Role.EMPLOYEE]}
                  >
                    <OrderDetail />
                  </PrivateRoute>
                }
              />
              <Route
                path=":id/edit"
                element={
                  <PrivateRoute
                    roles={[Role.ADMIN, Role.SELLER, Role.EMPLOYEE]}
                  >
                    <OrderDetail />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route
              path="design"
              element={
                <PrivateRoute roles={[Role.ADMIN, Role.SELLER, Role.EMPLOYEE]}>
                  <DesignList />
                </PrivateRoute>
              }
            />
            <Route
              path="stats"
              element={
                <PrivateRoute roles={[Role.ADMIN, Role.SELLER, Role.EMPLOYEE]}>
                  <Statistics />
                </PrivateRoute>
              }
            />
            <Route
              path="deposit-history"
              element={
                <PrivateRoute roles={[Role.SELLER]}>
                  <SellerDepositHistory />
                </PrivateRoute>
              }
            />
            {/* <Route
              path="phone"
              element={
                <PrivateRoute roles={[Role.ADMIN, Role.SELLER]}>
                  <PhoneCaseEditor />
                </PrivateRoute>
              }
            /> */}
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
